import { useTranslation } from "react-i18next";
import { Heart, Building, Music, Mic, GlassWater, ClipboardList, Check } from "lucide-react";

export function Services() {
  const { t } = useTranslation();

  const services = [
    {
      key: 'corporate',
      icon: Building,
      bgClass: 'from-amber-50/80 via-yellow-50/50 to-white'
    },
    {
      key: 'private',
      icon: GlassWater,
      bgClass: 'from-stone-50 via-amber-50/30 to-white'
    },
    {
      key: 'weddings',
      icon: Heart,
      bgClass: 'from-yellow-50/60 via-amber-50/40 to-white'
    },
    {
      key: 'planning',
      icon: ClipboardList,
      bgClass: 'from-stone-100/60 via-stone-50/40 to-white'
    },
    {
      key: 'festivals',
      icon: Music,
      bgClass: 'from-amber-50/60 via-yellow-50/30 to-white'
    },
    {
      key: 'concerts',
      icon: Mic,
      bgClass: 'from-neutral-100/60 via-stone-50/40 to-white'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-poppins font-bold text-4xl md:text-5xl text-dark mb-6" data-testid="services-title">
            {t('services.title')} <span className="text-primary">{t('services.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="services-subtitle">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = service.icon;
            return (
              <div 
                key={service.key}
                className={`bg-gradient-to-br ${service.bgClass} border-2 border-gray-200 rounded-2xl p-8 card-hover shadow-lg hover:shadow-xl transition-all duration-300`}
                data-testid={`service-${service.key}`}
              >
                <div className="text-primary mb-6">
                  <IconComponent className="w-10 h-10" />
                </div>
                <h3 className="font-poppins font-semibold text-2xl text-dark mb-4">
                  {t(`services.${service.key}.title`)}
                </h3>
                <p className="text-gray-600 mb-6">
                  {t(`services.${service.key}.description`)}
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  {(t(`services.${service.key}.features`, { returnObjects: true }) as string[]).map((feature: string, index: number) => (
                    <li key={index} className="flex items-center">
                      <Check className="w-4 h-4 text-primary mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
